import { Highlight } from 'react-instantsearch';
import { Dialog, Transition } from '@headlessui/react'
import { Fragment, useState } from "react";
import classNames from "classnames";

export function CardResourceEntry(props) {

    const resource = props?.hit;

    let [isOpen, setIsOpen] = useState(false)

    function closeModal() {
        setIsOpen(false)
    }

    function openModal(e) {
        e.preventDefault();
        setIsOpen(true)
    }

    function getYouTubeID(url) {
        var regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
        var match = url.match(regExp);
        if (match && match[2].length == 11) {
          return match[2];
        } else {
            return false;
        }                
    }


    function PreviewResource() {
        let extension = resource.extension;
        switch(extension) {
            case 'pdf':
                return resource.extension == 'pdf' && <iframe className='pdf-frame w-full h-full' id={'frame_' + resource.id}
                title={resource.title}
                width="100%"
                height="auto"
                src={"https://drive.google.com/viewerng/viewer?embedded=true&url=" + resource.url}>
            </iframe>
            case 'json':
                // 
                let videoId = getYouTubeID(resource.url);
                if (videoId) {
                    return resource.extension == 'json' && <div className='aspect-video video-container'><iframe className='aspect-video' id={'video_frame_' + resource.id}
                    title={resource.title}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen=""
                    width="1920"
                    height="1080"
                    src={'https://www.youtube-nocookie.com/embed/'+ videoId + '?feature=oembed'}></iframe></div>
                }
            default:
              return <img className="mx-auto w-full h-auto" src={resource.img} />;
          }
    }

    function ProductList() {
        const skus = resource.product_skus;
        if (skus.length <= 5) {
            return (<div className='text-xs text-brand-blue-200 uppercase mt-2'>{skus.map(function(item, index) {return <span key={index}>{ (index ? ', ' : '') + item }</span>})}</div>);
        }
    }

    
    return (
        <div className="resource-card">
            <div
                className="p-2 sm:p-4 md:p-8 aspect-[9/11] bg-brand-blue-50 border border-brand-blue-50 hover:border-brand-blue-200 hover:text-brand-blue-500 transition-all duration-300 rounded-lg h-full flex flex-col relative">

                <div className="aspect-[9/11] bg-contain bg-no-repeat bg-center"
                     style={{backgroundImage: `url(${resource.img})`}}></div>

                <div
                    className="resource-actions opacity-0 invisible absolute rounded-lg top-0 left-0 w-full h-full flex items-center justify-center bg-[#131F28]/70 gap-2 duration-300">

                    <a onClick={openModal}
                       className="bg-white text-brand-blue-900 hover:text-brand-blue-500 h-12 w-12 sm:h-16 sm:w-16 rounded-full flex items-center justify-center"
                       href="#">
                        <svg className="h-4 w-4 sm:h-6 sm:w-6 text-current" width="25" height="24" viewBox="0 0 25 24"
                             fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M2.92012 12.7132C2.78394 12.4975 2.71584 12.3897 2.67772 12.2234C2.64909 12.0985 2.64909 11.9015 2.67772 11.7766C2.71584 11.6103 2.78394 11.5025 2.92012 11.2868C4.04553 9.50484 7.3954 5 12.5004 5C17.6054 5 20.9553 9.50484 22.0807 11.2868C22.2169 11.5025 22.285 11.6103 22.3231 11.7766C22.3517 11.9015 22.3517 12.0985 22.3231 12.2234C22.285 12.3897 22.2169 12.4975 22.0807 12.7132C20.9553 14.4952 17.6054 19 12.5004 19C7.3954 19 4.04553 14.4952 2.92012 12.7132Z"
                                stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                            <path
                                d="M12.5004 15C14.1573 15 15.5004 13.6569 15.5004 12C15.5004 10.3431 14.1573 9 12.5004 9C10.8435 9 9.5004 10.3431 9.5004 12C9.5004 13.6569 10.8435 15 12.5004 15Z"
                                stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </a>

                    {resource.extension !== 'json' &&

                        <a className="bg-white text-brand-blue-900 hover:text-brand-blue-500 h-12 w-12 sm:h-16 sm:w-16 rounded-full flex items-center justify-center"
                           href={'/resources/download/' + resource.id} onClick={() => {
                            props.sendEvent('click', resource, 'Resource Downloaded')
                        }}>
                            <svg className="h-4 w-4 sm:h-6 sm:w-6 text-current" width="21" height="20"
                                 viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M19.5 13V14.2C19.5 15.8802 19.5 16.7202 19.173 17.362C18.8854 17.9265 18.4265 18.3854 17.862 18.673C17.2202 19 16.3802 19 14.7 19H6.3C4.61984 19 3.77976 19 3.13803 18.673C2.57354 18.3854 2.1146 17.9265 1.82698 17.362C1.5 16.7202 1.5 15.8802 1.5 14.2V13M15.5 8L10.5 13M10.5 13L5.5 8M10.5 13V1"
                                    stroke="currentColor" strokeWidth="1.25" strokeLinecap="round"
                                    strokeLinejoin="round"/>
                            </svg>
                        </a>
                    }

                    {/*
                    <a className="bg-white text-brand-blue-900 hover:text-brand-blue-500 h-16 w-16 rounded-full flex items-center justify-center" href="#">
                        <svg className="h-6 w-6 text-current" width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19.2914 10.6075C19.5355 10.3982 19.6575 10.2936 19.7023 10.1691C19.7415 10.0598 19.7415 9.94028 19.7023 9.83101C19.6575 9.70651 19.5355 9.60189 19.2914 9.39264L10.8206 2.13202C10.4004 1.77182 10.1903 1.59172 10.0124 1.58731C9.8578 1.58348 9.71012 1.6514 9.61242 1.77128C9.5 1.90921 9.5 2.18595 9.5 2.73942V7.03468C7.36532 7.40813 5.41159 8.4898 3.95971 10.1139C2.37682 11.8846 1.50123 14.176 1.5 16.551V17.163C2.54934 15.8989 3.85951 14.8766 5.34076 14.166C6.6467 13.5395 8.05842 13.1684 9.5 13.0706V17.2607C9.5 17.8141 9.5 18.0909 9.61242 18.2288C9.71012 18.3487 9.8578 18.4166 10.0124 18.4128C10.1903 18.4084 10.4004 18.2283 10.8206 17.8681L19.2914 10.6075Z" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </a>
                    */}

                </div>

            </div>

            <h3 className="font-medium text-lg/none xl:text-xl/6 mt-4 mb-2 text-brand-blue-900">
                <a href={'/resources/view/' + resource.id} onClick={() => {
                    props.sendEvent('click', resource, 'Resource Clicked')
                }}>
                    {resource.type == 'Discontinued' ? (
                        <div className="inline" x-data="discontinued('true', 'top')">
                            <Highlight attribute="title" classNames={{highlighted: 'bg-brand-blue-50'}} hit={resource}/>
                        </div>
                        ) : (
                        <Highlight attribute="title" classNames={{highlighted: 'bg-brand-blue-50'}} hit={resource}/>
                    )}
                </a>

            </h3>

            <div className=" text-brand-blue-500 text-base">
                {resource.type}
            </div>

            <ProductList/>


            <Transition appear show={isOpen} as={Fragment}>
                <Dialog as="div" className="relative z-50" onClose={closeModal}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className={`fixed inset-0 bg-black/50`}/>
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel
                                    className="relative w-full max-w-screen-xl overflow-hidden rounded-2xl bg-white p-6 lg:p-8 xl:p-12 text-left align-middle shadow-xl transition-all">
                                    <div className="mt-2">
                                        <div className="flex flex-col lg:flex-row gap-8 lg:gap-8">
                                            <div className="lg:basis-1/2">
                                                <div
                                                    className={classNames('h-full', {'aspect-[9/11]': resource.extension == 'pdf'})}>
                                                    <PreviewResource/>
                                                </div>
                                            </div>
                                            <div className='lg:flex items-center basis-1/2'>
                                                <div className="md:p-4 lg:p-8 xl:py-12">

                                                    <div
                                                        className="text-xl md:text-2xl text-brand-blue-300">{resource.type}</div>
                                                    <h3 className="leading-tight text-3xl md:text-4xl text-brand-blue-900">{resource.title}</h3>
                                                    <div
                                                        className="mt-6 flex flex-col sm:flex-row sm:items-center sm:justify-start gap-4">

                                                        {resource.extension == 'json' &&

                                                            <div
                                                                className="mt-6 flex flex-col sm:flex-row sm:items-center sm:justify-start gap-4">
                                                                <a href={'/resources/view/' + resource.id}
                                                                   className="button small has-icon" onClick={() => {
                                                                    props.sendEvent('click', resource, 'Resource Clicked')
                                                                }}>
                                                                    <svg className="w-6 h-auto text-current"
                                                                         xmlns="http://www.w3.org/2000/svg" width="36"
                                                                         height="36" fill="currentColor"
                                                                         viewBox="0 0 256 256">
                                                                        <path
                                                                            d="M240,128a15.74,15.74,0,0,1-7.6,13.51L88.32,229.65a16,16,0,0,1-16.2.3A15.86,15.86,0,0,1,64,216.13V39.87a15.86,15.86,0,0,1,8.12-13.82,16,16,0,0,1,16.2.3L232.4,114.49A15.74,15.74,0,0,1,240,128Z"></path>
                                                                    </svg>
                                                                    View
                                                                </a>
                                                            </div>
                                                        }

                                                        {resource.extension != 'json' &&
                                                            <div
                                                                className="mt-6 flex flex-col sm:flex-row items-center sm:justify-start gap-4">

                                                                <a href={resource.url} className="button small has-icon"
                                                                   target="_blank" onClick={() => {
                                                                    props.sendEvent('click', resource, 'Resource Clicked')
                                                                }}>
                                                                    <svg className="w-6 h-auto text-current" width="25"
                                                                         height="24" viewBox="0 0 25 24" fill="none"
                                                                         xmlns="http://www.w3.org/2000/svg">
                                                                        <path
                                                                            d="M2.92012 12.7132C2.78394 12.4975 2.71584 12.3897 2.67772 12.2234C2.64909 12.0985 2.64909 11.9015 2.67772 11.7766C2.71584 11.6103 2.78394 11.5025 2.92012 11.2868C4.04553 9.50484 7.3954 5 12.5004 5C17.6054 5 20.9553 9.50484 22.0807 11.2868C22.2169 11.5025 22.285 11.6103 22.3231 11.7766C22.3517 11.9015 22.3517 12.0985 22.3231 12.2234C22.285 12.3897 22.2169 12.4975 22.0807 12.7132C20.9553 14.4952 17.6054 19 12.5004 19C7.3954 19 4.04553 14.4952 2.92012 12.7132Z"
                                                                            stroke="currentColor" strokeWidth="1.25"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"></path>
                                                                        <path
                                                                            d="M12.5004 15C14.1573 15 15.5004 13.6569 15.5004 12C15.5004 10.3431 14.1573 9 12.5004 9C10.8435 9 9.5004 10.3431 9.5004 12C9.5004 13.6569 10.8435 15 12.5004 15Z"
                                                                            stroke="currentColor" stroke-width="1.25"
                                                                            stroke-linecap="round"
                                                                            stroke-linejoin="round"></path>
                                                                    </svg>
                                                                    View
                                                                </a>

                                                                <a href={'/resources/download/' + resource.id}
                                                                   className="button small has-icon" target="_blank"
                                                                   onClick={() => {
                                                                       props.sendEvent('click', resource, 'Resource Downloaded')
                                                                   }}>
                                                                    <svg className="w-6 h-auto text-current" width="17"
                                                                         height="17" viewBox="0 0 17 17" fill="none"
                                                                         xmlns="http://www.w3.org/2000/svg">
                                                                        <path
                                                                            d="M15.9375 11.4111V12.4111C15.9375 13.8113 15.9375 14.5113 15.665 15.0461C15.4253 15.5165 15.0429 15.899 14.5725 16.1386C14.0377 16.4111 13.3376 16.4111 11.9375 16.4111H4.9375C3.53737 16.4111 2.8373 16.4111 2.30252 16.1386C1.83212 15.899 1.44967 15.5165 1.20998 15.0461C0.9375 14.5113 0.9375 13.8113 0.9375 12.4111V11.4111M12.6042 7.24447L8.4375 11.4111M8.4375 11.4111L4.27083 7.24447M8.4375 11.4111V1.41113"
                                                                            stroke="currentColor" strokeLinecap="round"
                                                                            strokeLinejoin="round"/>
                                                                    </svg>
                                                                    Download
                                                                </a>

                                                                <a href={'/resources/view/' + resource.id}
                                                                   className="button small text with-icon lg:ml-3"
                                                                   onClick={() => {
                                                                       props.sendEvent('click', resource, 'Resource Clicked')
                                                                   }}>
                                                                    Detail Page
                                                                    <svg className="w-4 h-auto text-current"
                                                                         xmlns="http://www.w3.org/2000/svg" width="36"
                                                                         height="36" fill="currentColor"
                                                                         viewBox="0 0 256 256">
                                                                        <path
                                                                            d="M220.24,132.24l-72,72a6,6,0,0,1-8.48-8.48L201.51,134H40a6,6,0,0,1,0-12H201.51L139.76,60.24a6,6,0,0,1,8.48-8.48l72,72A6,6,0,0,1,220.24,132.24Z"></path>
                                                                    </svg>
                                                                </a>

                                                            </div>
                                                        }

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <button type="button"
                                            className="absolute top-3 right-3 inline-flex items-center justify-center"
                                            onClick={closeModal}>
                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path d="M24 8L8 24" stroke="#9CA3AB" strokeLinecap="square"/>
                                            <path d="M8 8L24 24" stroke="#9CA3AB" strokeLinecap="square"/>
                                        </svg>
                                    </button>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </div>
    )
}